export const roleConstants = {
    SUPERUSERUMPI: 1,
    ADMIN: 2, 
    GUEST: 3 
};



// WEBPACK FOOTER //
// ./src/constants/role.constants.js